export default {
    name: 'DirectDebit',
    dimensions: { width: 24, height: 17 },
    content: `
    <path d="M10 10.75H8V6.75H10C11.1 6.75 12 7.65 12 8.75C12 9.85 11.1 10.75 10 10.75Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 10.75H12V6.75H14C15.1 6.75 16 7.65 16 8.75C16 9.85 15.1 10.75 14 10.75Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 6.75H12" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 10.75H12" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <rect x="1" y="1.75" width="22" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>
  `
};
